export const ADMIN_MENU_ITEMS = [
  {
    id: '10',
    name: 'TM Intl Search',
    url: '/tmintl',
    child: [],
    parent_id: null,
  },
  {
    id: '2',
    name: 'Event Search',
    url: '/',
    child: [],
    parent_id: null,
  },
  {
    id: '3',
    name: 'New Search',
    url: '/newSearch',
    child: [],
    parent_id: null,
  },
  {
    id: '4',
    name: 'Filter Notifications',
    url: '/notifications',
    child: [],
    parent_id: null,
  },
  {
    id: '5',
    name: 'Threshold Notifications',
    url: '/threshold',
    child: [],
    parent_id: null,
  },
  {
    id: '6',
    name: 'Killshot',
    url: '',
    child: [
      {
        id: '11',
        name: 'Sales Stream',
        url: '/sales-stream',
        parent_id: '6',
        new_tab: true,
      },
      {
        id: '7',
        name: 'Inventory Manager',
        url: '/killshot',
        parent_id: '6',
      },
      {
        id: -1,
        name: 'Admin Settings',
        parent_id: 6,
        url: '/settings',
      },
    ],
    parent_id: null,
  },
];

export const MENU_ITEMS = [
  {
    id: '10',
    name: 'TM Intl Search',
    url: '/tmintl',
    child: [],
    parent_id: null,
  },
  {
    id: '2',
    name: 'Event Search',
    url: '/',
    child: [],
    parent_id: null,
  },
  {
    id: '3',
    name: 'New Search',
    url: '/newSearch',
    child: [],
    parent_id: null,
  },
  {
    id: '4',
    name: 'Filter Notifications',
    url: '/notifications',
    child: [],
    parent_id: null,
  },
  {
    id: '5',
    name: 'Threshold Notifications',
    url: '/threshold',
    child: [],
    parent_id: null,
  },
  {
    id: '6',
    name: 'Killshot',
    url: '',
    child: [
      {
        id: '11',
        name: 'Sales Stream',
        url: '/sales-stream',
        parent_id: '6',
        new_tab: true,
      },
      {
        id: '7',
        name: 'Inventory Manager',
        url: '/killshot',
        parent_id: '6',
      },
    ],
    parent_id: null,
  },
];
